import { Tag, TagColor } from '@factorialco/deprecated-design-system'
import { BankingEntitiesCardPaymentCalculatedLabelEnum } from 'generated/resources/graphql'

export const statusTagColor = (
  internalStatus: BankingEntitiesCardPaymentCalculatedLabelEnum
): TagColor => {
  switch (internalStatus) {
    case 'complete':
      return Tag.Types.lime
    case 'decline':
      return Tag.Types.radical
    case 'refund':
      return Tag.Types.champagne
    case 'reverse':
      return Tag.Types.champagne
    case 'withhold':
      return Tag.Types.grey
  }
}
